define([
    'web/common/api'
], function(
    CommonApi
){
    var Api = CommonApi.Api;
    return {
        multiPromise: CommonApi.multiPromise,
        getCooperateCfgApi: new Api('/s/sitecooperate/getCfg'),
        addCooperateApi: new Api('/s/sitecooperate/add', {type: 'POST'}),
        uploadApi: new Api('/m/s/upload', {
            type:'POST',
            processData: false,
            contentType: false
        }),
        getCommonEnumApi: new Api('/m/s/common/enum')
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2024-buyChannel/api.js
// module id = 122
// module chunks = 4 5